import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 *
 * 获取预约规则表列表 get
 * @param query 分页参数
 * @return request
 * */
export function getRuleList(query) {
    return request({
        url: `${baseURL.businessApi}/rules`,
        method: 'get',
        params: query
    })
}

/**
 * 增加预约规则表 post
 * @param data 增加的数据
 * @return request
 * */
export function addRule(data) {
    return request({
        url: `${baseURL.businessApi}/rules`,
        method: 'post',
        data: data
    })
}

/**
 * 删除预约规则表  delete
 * @param id 预约规则表id
 * @return request
 * */
export function deleteRule(id) {
    return request({
        url: `${baseURL.businessApi}/rules/${id}`,
        method: 'delete'
    })
}

/***
 * 修改预约规则表 Post
 * @param id 要修改的预约规则表id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateRule(id, data) {
    return request({
        url: `${baseURL.businessApi}/rules/${id}`,
        method: 'post',
        data: data
    })
}

export function updateEnclosure(data,query) {
    return request({
        url: `${baseURL.businessApi}/email/enclosure`,
        method: 'post',
        data: data,
        params: query
    })
}
